import {getQuery} from "@/modules/common/utils";

const search = (params) => getQuery('search', params);

export default {
  search
}
